import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, getDefaultRouteForRole } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const { completeGoogleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(location.hash.replace("#", "?")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      const result = await completeGoogleLogin(sessionId);
      window.history.replaceState({}, "", window.location.pathname);
      if (result.success) {
        navigate(getDefaultRouteForRole(result.user.role), { replace: true, state: { user: result.user } });
      } else {
        navigate("/login", { replace: true, state: { error: result.error } });
      }
    })();
  }, [completeGoogleLogin, location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-amtm-bg" data-testid="auth-callback-loading">
      <Loader2 className="h-8 w-8 animate-spin text-amtm-teal" />
    </div>
  );
}
